<div *ngIf='materials'>
  <div class='form-container' *ngIf='(materials && materials.length === 0) || materials.length > 0' id='top'>
    <!-- HEADER -->
    <div class='col-12 row heading'>
      <div class='results-heading-title'>
        <div class='subtitle'>{{ 'STOCK_COUNT.CREATE_RESULTS_MATERIALS.TITLE' | translate }}</div>
      </div>
    </div>

    <!-- COLUMNS -->
    <div class='col-12 row bottom-line bold show-from-sm sorters' *ngIf='materials.length > 0'>
      <div class='col-container' *ngFor='let col of columns'>
        <span>
          {{ col.colName }}
        </span>
      </div>
    </div>

    <!-- ROWS -->
    <div *ngFor='let material of materials' class='col-12 row cell-row soft-line col-el-2'>
      <!-- COMPONENT -->
      <app-stock-count-material
        class='col-el'
        [class.valid-material]='materialValid(material.packingID)'
        [columns]='columns'
        [material]='material'
        [shipTos]='shipTos'
        [definitions]='definitions'
        (addCountedMaterial)='addCountedMaterial($event)'
        (removeCountedMaterial)='removeCountedMaterial($event)'
        (updateCountedMaterial)='updateCountedMaterial($event)'
      >
      </app-stock-count-material>
    </div>

    <div class='hr'></div>

    <div class='col-11 col-md-12 order_line comment_container'>
      <div class='content'>
        <div class='row order_data'>
          <div class='row col-md-2'>
            <app-label translationCode='STOCK_COUNT.LABELS.COMMENT'></app-label>
          </div>
          <div class='row col-md-10'>
            <textarea class='comment' [(ngModel)]='comment'></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- BUTTONS -->
    <div class='hr'></div>

    <div class='buttons save-button'>
      <div class='hr-thick'></div>
      <a class='btn-cancel hand' (click)='cancelClicked()'>{{ 'SHARED.BUTTONS.CANCEL' | translate }}</a>
      <a mat-raised-button class='primary' (click)='createStockCount()' [disabled]='!allCounted'>
        <i class='fa fa-check' aria-hidden='true'></i>
        <span>{{ 'STOCK_COUNT.BUTTONS.CREATE_STOCK_COUNT' | translate }}</span>
      </a>
    </div>
  </div>
</div>
